<!-- "HQ processing" becomes a link to the job in the jobs list for staff, otherwise plain text. -->
<ng-template #hqLabel>
    @if ($can().read.menu("jobs")) {
        <a [routerLink]="['/jobs', $jobId()]" class="cm-job-link" matTooltip="Open this job in the jobs list">HQ processing</a>
    } @else {
        HQ processing
    }
</ng-template>
@if ($isCancelled()) {
    <cm-hint [hintType]="HintTypes.Warning">
        <ng-container cm-text> <ng-container [ngTemplateOutlet]="hqLabel"></ng-container> was cancelled!{{ $label() ? " " + $label() : "" }}</ng-container>
    </cm-hint>
} @else if ($isFailed()) {
    <cm-hint [hintType]="HintTypes.Warning">
        <ng-container cm-text> <ng-container [ngTemplateOutlet]="hqLabel"></ng-container> has failed!{{ $label() ? " " + $label() : "" }}</ng-container>
    </cm-hint>
} @else if ($isProcessing()) {
    <cm-hint>
        <ng-container cm-text>
            <ng-container [ngTemplateOutlet]="hqLabel"></ng-container> is currently in progress...{{ $label() ? " " + $label() : "" }}
            <mat-progress-bar mode="determinate" [value]="$progress()"></mat-progress-bar>
        </ng-container>
    </cm-hint>
}
